import { FC, useState, useEffect } from 'react'

type ProductCountdownProps = {
  date?: string
  discount?: string
}

type TimeLeft = {
  days: number
  hours: number
  min: number
  sec: number
}

export const ProductCountdown: FC<ProductCountdownProps> = (props) => {
  const { date, discount } = props
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    min: 0,
    sec: 0,
  })
  const [complete, setComplete] = useState(false)

  useEffect(() => {
    if (!date) return

    const targetDate = new Date(date).getTime()

    const updateCountdown = () => {
      const now = new Date().getTime()
      const distance = targetDate - now

      if (distance < 0) {
        setComplete(true)
        return
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const sec = Math.floor((distance % (1000 * 60)) / 1000)

      setTimeLeft({ days, hours, min, sec })
    }

    updateCountdown()

    const intervalId = setInterval(updateCountdown, 1000)

    return () => clearInterval(intervalId)
  }, [date])

  if (!date || timeLeft.sec <= 0 || complete) return null

  return (
    <div className="flex w-full flex-col items-start gap-8 pb-32 pt-20">
      {discount ? (
        <div className="text-11 uppercase leading-100 text-darkGray">
          {discount} off ending soon
        </div>
      ) : (
        <div className="text-11 uppercase leading-100 text-darkGray">
          Shipping soon
        </div>
      )}
      <div
        suppressHydrationWarning
        className="flex h-40 w-full items-center justify-start gap-24 rounded-8 bg-white px-12 text-13 font-medium leading-100 md:gap-32"
      >
        {Object.keys(timeLeft).map((key) => (
          <div key={key} className="flex items-end gap-4 leading-100">
            <span className="tabular-nums -tracking-[0.04em]">
              {timeLeft[key]}
            </span>
            <span className="text-9 uppercase leading-110">{key}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
